export const removeFilter = (tableFilters, id) => {
  return tableFilters.filter(filter => filter.id !== id)
};
